import { Paragraph } from "@smartsuite/react-ui/lib/components/typography/Paragraph/Paragraph";
import type React from "react";

export const ErrorPage: React.FC = () => {
  return <Paragraph>Not found</Paragraph>;
};
